import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "We're an experienced software team with deep PHP expertise across many domains. When off-the-shelf tools can't keep up, we build custom PHP applications that fit your exact process rather than forcing you to fit theirs.",
    "From HTML5 front ends to core PHP and MySQL back ends, we design, build and maintain systems that are secure, scalable and straightforward for your team to run.",
];

const FEATURES = [
    { title: "Tailored to your workflow", text: "Every screen and rule is built around the way your business really operates." },
    { title: "Core PHP & frameworks", text: "We work in core PHP, Laravel and CodeIgniter — the right tool for the job." },
    { title: "Reliable & secure", text: "Clean architecture, validation and testing keep your data safe and the app stable." },
    { title: "Built to scale", text: "Solutions are structured to grow with you, from first release to heavy load." },
];

const CHECKS = [
    "HTML5 application development",
    "Core PHP development",
    "PHP & MySQL web apps",
    "API design & integration",
    "Maintenance & support",
];

export default function CustomPhpSoftwareSolutions() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Web Development" title="Custom PHP Software Solutions" eyebrowAs="span">
                    Bespoke software built in core PHP and modern frameworks — vibrant, dependable solutions shaped around how your business actually works.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
